/**
 * 闪烁动画
 */
import fvAnimation from "./fvAnimation"
export default class fvTwinkel extends fvAnimation {
    constructor(shape){
        super(shape,"fvTwinkel");
        //为了让run顺序执行，提前准备好所需数据、方法、属性等

        //表达式
        this.excExpression = AsyncFunction("return " + this.expression);;
        //动画模板函数
        this.runAnimation = this.model == "c" ?this.twinkle: this.fade;
        //动画刷新间隔
        this.nTickCount = Date.now();
        //保存原始shape 的填充、边线颜色
        this.shape.initFcHide = this.shape.fcHide;
        this.oldColor = this.shape.outsideColor;
        this.shape.colorOldFillColor = this.shape.color;
        this.shape.colorOldBorderColor = this.shape.borderColor;
        //智能单元初始化所有图元赋值
        this.initIsSubObjects(this.shape);
        this.count;
        if(this.speed == 0){
            this.count = 3000;
        }else if(this.speed == 1){
            this.count = 1500;
        }else{
            this.count = 1000;
        }
        // 图元闪烁或者显隐 表达式false重置。
        this.flag = true;
    }

    //初始化定义color和borderColor
    initIsSubObjects(shape){
        if(shape.fctype == "fvGroupObj" && shape.subObjects){
            for (var p in shape.subObjects) {
                try {
                    if(p == "$"){
                        continue;
                    }
                    if(shape.subObjects[p].$.fctype == "fvGroupObj" && shape.subObjects){
                        this.initIsSubObjects(shape.subObjects[p].$);
                    }else{
                        shape.subObjects[p].$.colorOldFillColor = shape.subObjects[p].$.color;
                        shape.subObjects[p].$.colorOldBorderColor = shape.subObjects[p].$.borderColor;
                    }
                }catch(error){
                    console.log(error);
                }
            }
        }
    }
    async run(canvas,value){
        //if(value == false) return;
       var size = await this.executionScript(this.excExpression);
        var nowTime = Date.now();
        if(nowTime - this.nTickCount >= this.count){
            //大于间隔处理才处理动画逻辑
            this.nTickCount = nowTime;
            this.flag = false;
            if(size){
                this.flag = false;
                this.runAnimation();
            }else{
                this.flag = true;
                this.runAnimation();
            }
            super.run();
        }
    }
    twinkle(){
        this.isSubObjectsTwinkle(this.shape);
        this.animationExecutionTwinkle(this.shape);
    }
    //递归调用每一层图元
    isSubObjectsTwinkle(shape){
        if(shape.fctype == "fvGroupObj" && shape.subObjects){
            for (var p in shape.subObjects) {
                try {
                    if(p == "$"){
                        continue;
                    }
                    if(shape.subObjects[p].$.fctype == "fvGroupObj" && shape.subObjects){
                        this.isSubObjectsTwinkle(shape.subObjects[p].$);
                    }else{
                        this.animationExecutionTwinkle(shape.subObjects[p].$);
                    }
                }catch(error){
                    console.log(error);
                }
            }
            return false;
        }
    }
    //闪烁动画执行
    animationExecutionTwinkle(shape){
        //管道颜色
        if(shape.fctype == "fvPipeObj"){
            if(this.flag){
                shape.color = shape.colorOldBorderColor;
            }else{
                shape.outsideColor = shape.outsideColor == this.fillColor ? this.oldColor : this.fillColor;
            }
        }else if(shape.fctype == "fvTextObj"){
            //文本颜色
            if(this.flag){
                shape.color = shape.colorOldFillColor;
            }else{
                shape.color = shape.color == shape.colorOldFillColor ? this.borderColor : shape.colorOldFillColor;

            }
        }else{
            if(this.flag){
                shape.color = shape.colorOldFillColor;
                shape.borderColor = shape.colorOldBorderColor;
            }else{
                //  填充颜色
                //  判断当前颜色是否转为rgba，因为在椭圆矩形中存在rgba颜色转换
                if(shape.color.toLowerCase().indexOf("rgba")>-1){
                    var rgbArray = shape.colorOldFillColor.colorRgb(shape.opacity/255).toLowerCase();
                    shape.color =  shape.color.toLowerCase() == rgbArray ?  this.fillColor : rgbArray;
                }else{
                    shape.color = shape.color == shape.colorOldFillColor ? this.fillColor : shape.colorOldFillColor;
                }
                //边框颜色
                shape.borderColor = shape.borderColor == shape.colorOldBorderColor ? this.borderColor : shape.colorOldBorderColor;
            }
        }
    }

    fade(){
        this.isSubObjectsFade(this.shape);
       this.animationExecutionFade(this.shape);
    }
    //递归调用每一层图元
    isSubObjectsFade(shape){
        if(shape.fctype == "fvGroupObj" && shape.subObjects){
            for (var p in shape.subObjects) {
                try {
                    if(p == "$"){
                        continue;
                    }
                    if(shape.subObjects[p].$.fctype == "fvGroupObj" && shape.subObjects){
                        this.isSubObjectsFade(shape.subObjects[p].$);
                    }else{
                        this.animationExecutionFade(shape.subObjects[p].$);
                    }
                }catch(error){
                    console.log(error);
                }
            }
            return false;
        }
    }
    //显隐动画执行
    animationExecutionFade(shape){
        if(this.flag){
            shape.Show(shape.initFcHide, 'animation');
            
        }else{
            shape.Show(shape.fcHide, 'animation');
            shape.fcHide=!shape.fcHide;
           
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvTwinkel.js